export const moduleChoiceReferences: { [key: string]: string } = {
    1: 'Entyvio Summary of Product Characteristics. 2022',
}

export const moduleChoiceLogoReferences: { [key: string]: string } = {
    1: 'Bamias G, et al. Clin. Gastroenterol. Hepatol. 2020. doi:10.1016/j.cgh.2020.09.023.',
    2: 'Eksteen B, et al. Inflamm Bowel Dis. 2008;14:1298–312.',
    3: 'Arseneau KO, et al. Clin Pharmacol Ther. 2015;97:22–8.',
    4: 'Neurath MF. Nat. Rev. 2014;14:329–42.',
    5: 'Silva FAR, et al. Gastroenterol Res Pract. 2016. doi:10.1155/2016/2097274.',
    6: 'Sange AH, et al. Cureus. doi:10.7759/cureus.17187.',
}